import Vue from 'vue';
import Router from 'vue-router';

import AvailableCourses from '@/views/AvailableCourses';
import SavedCourses from '@/views/SavedCourses';
import CteOverview from '@/views/CteOverview';
import SectorInfo from '@/views/SectorInfo';
import ProgramOfStudy from '@/views/ProgramOfStudy';
import YourPlan from '@/views/YourPlan';

Vue.use( Router );

export default new Router( {
  mode   : 'history',
  base   : process.env.BASE_URL,
  routes : [
    {
      path     : '/',
      redirect : '/courses',
      props    : { view : 'courses' }
    },
    {
      path      : '/courses',
      name      : 'Courses',
      component : AvailableCourses,
    },
    {
      path      : '/saved',
      name      : 'Saved',
      component : SavedCourses,
      props     : { view : 'saved' }
    },
    {
      path      : '/cte',
      name      : 'CTE',
      component : CteOverview,
    },
    {
      path      : '/sector-info',
      name      : 'Sector Info',
      component : SectorInfo,
    },
    {
      path      : '/program-of-study',
      name      : 'Program of Study',
      component : ProgramOfStudy
    },
    {
      path      : '/your-plan',
      name      : 'Your Plan',
      component : YourPlan
    },
    {
      path     : '*',
      redirect : '/courses'
    }
  ],
} );
